/* =========================================================
   INKSOFT API MODULE
========================================================= */

window.InksoftPOC = window.InksoftPOC || {};

window.InksoftPOC.api = (function () {

  const core = window.InksoftPOC.core || {};

  const API_BASE =
    window.InksoftPOC.API_BASE ||
    '/apps/inksoft';

  const DEFAULT_TIMEOUT = 20000;

  /* =========================================================
     INTERNAL HELPERS
  ========================================================= */

  function asString(value) {
    return value == null ? '' : String(value).trim();
  }

  function buildUrl(path) {
    path = asString(path);

    if (!path) {
      return API_BASE;
    }

    if (path.charAt(0) !== '/') {
      path = '/' + path;
    }

    return API_BASE + path;
  }

  function buildQuery(params) {
    if (!params || typeof params !== 'object') {
      return '';
    }

    const search = new URLSearchParams();

    Object.keys(params).forEach(function (key) {
      const value = params[key];

      if (
        value === undefined ||
        value === null ||
        value === ''
      ) {
        return;
      }

      search.append(key, String(value));
    });

    const query = search.toString();

    return query ? ('?' + query) : '';
  }

  function createTimeoutSignal(timeoutMs) {
    if (
      typeof AbortController === 'undefined'
    ) {
      return null;
    }

    const controller = new AbortController();

    setTimeout(function () {
      controller.abort();
    }, timeoutMs || DEFAULT_TIMEOUT);

    return controller;
  }

  /* =========================================================
     CORE FETCH
  ========================================================= */

  async function fetchJson(path, options) {

    options = options || {};

    const timeoutMs =
      Number(options.timeout) > 0
        ? Number(options.timeout)
        : DEFAULT_TIMEOUT;

    const controller =
      createTimeoutSignal(timeoutMs);

    const fetchOptions = {
      method: options.method || 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    };

    if (options.headers) {
      Object.assign(fetchOptions.headers, options.headers);
    }

    if (controller) {
      fetchOptions.signal = controller.signal;
    }

    if (options.body != null) {
      fetchOptions.body =
        typeof options.body === 'string'
          ? options.body
          : JSON.stringify(options.body);

      if (!fetchOptions.headers['Content-Type']) {
        fetchOptions.headers['Content-Type'] =
          'application/json';
      }
    }

    const url = buildUrl(path);

    let response;

    try {

      response = await fetch(url, fetchOptions);

    } catch (err) {

      console.error(
        '[Inksoft API] Network error:',
        url,
        err
      );

      throw new Error(
        'Network request failed.'
      );
    }

    if (!response.ok) {

      console.error(
        '[Inksoft API] HTTP error:',
        response.status,
        url
      );

      throw new Error(
        'HTTP ' + response.status
      );
    }

    let json;

    try {

      json = await response.json();

    } catch (err) {

      console.error(
        '[Inksoft API] Invalid JSON:',
        url,
        err
      );

      throw new Error(
        'Invalid JSON response.'
      );
    }

    return json;
  }

  /* =========================================================
     PRODUCTS
  ========================================================= */

  async function getProduct(productId) {

    return fetchJson(
      '/product' +
      buildQuery({
        id: productId
      })
    );
  }

  async function getProducts(params) {

    return fetchJson(
      '/products' +
      buildQuery(params || {})
    );
  }

  /* =========================================================
     RELATED PRODUCTS
  ========================================================= */

  async function getRelatedProducts(productId) {

    return fetchJson(
      '/product-related' +
      buildQuery({
        id: productId
      })
    );
  }

  /* =========================================================
     DESIGN IDEAS
  ========================================================= */

  async function getDesignIdeas(params) {

    return fetchJson(
      '/designs' +
      buildQuery(params || {})
    );
  }

  async function getDesignIdeasByCategory(categoryId) {

    return fetchJson(
      '/designs/by-category' +
      buildQuery({
        categoryId: categoryId
      })
    );
  }

  /* =========================================================
     DESIGN MAP / PREVIEW
  ========================================================= */

  async function getDesignMap(params) {

    return fetchJson(
      '/design-map' +
      buildQuery(params || {})
    );
  }

  /* =========================================================
     DESIGNER
  ========================================================= */

  async function prepareDesigner(payload) {

    return fetchJson(
      '/designer/prepare',
      {
        method: 'POST',
        body: payload || {}
      }
    );
  }

  /* =========================================================
     QUOTE
  ========================================================= */

  async function uploadQuote(payload) {

    return fetchJson(
      '/upload-quote',
      {
        method: 'POST',
        body: payload || {}
      }
    );
  }

  /* =========================================================
     CART
  ========================================================= */

  async function addToInksoftCart(payload) {

    return fetchJson(
      '/inksoft-cart',
      {
        method: 'POST',
        body: payload || {}
      }
    );
  }

  /* =========================================================
     PUBLIC API
  ========================================================= */

  return {

    API_BASE: API_BASE,

    fetchJson: fetchJson,

    getProduct: getProduct,
    getProducts: getProducts,

    getRelatedProducts: getRelatedProducts,

    getDesignIdeas: getDesignIdeas,
    getDesignIdeasByCategory: getDesignIdeasByCategory,

    getDesignMap: getDesignMap,

    prepareDesigner: prepareDesigner,

    uploadQuote: uploadQuote,

    addToInksoftCart: addToInksoftCart
  };

})();